import multiViewComponentsPaths from "@helpers/multiViewComponentsPaths/multiViewComponentsPaths";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";
import React, { useState } from "react";
import { Col, Image, OverlayTrigger, Popover, Row, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaChartBar, FaGamepad, FaMailBulk, FaMapPin, FaPuzzlePiece, FaQrcode, FaTablet, FaUser } from "react-icons/fa";

const AtajosUsuarioEstudiante = ({ handleChangeComponent, handleUltimaLeccion, ultimaLeccion, rol, nombreUsuario }) => {

	const {t} = useTranslation();

	const [language, setLanguage] = useState(localStorage.getItem('i18nextLng') ? localStorage.getItem('i18nextLng') : document.querySelector('html').lang)

	const atajosItems = [
		{
			icon: <FaChartBar size={25} />,
			titulo: t("Advances"),
			descripcion: t('My Advances'),
			fondo: 'bg-avance',
			handleComponent: 'misAvances',
			targetTour: 'mis-avances',
			permittedTo: typesTiposUsuario.todosUsuarios + typesTiposUsuario.gestion,
		},

		{
			icon: <FaTablet size={25} />,
			titulo: t("Diagnostic title"),
			descripcion: t('Diagnostic examination'),
			fondo: 'bg-diagnostico',
			handleComponent: 'examenDiagnostico',
			targetTour: 'examenes-diagnostico',
			permittedTo: typesTiposUsuario.todosUsuarios,

		},
		{
			icon: <FaPuzzlePiece size={25} />,
			titulo: t("Learning title"),
			descripcion: t("Learning routes"),
			fondo: 'bg-ruta',
			handleComponent: 'rutasAprendizaje',
			targetTour: 'rutas-aprendizaje',
			permittedTo: typesTiposUsuario.todosUsuarios,

		},

		{
			icon: <FaGamepad size={25} />,
			titulo: t("Entertainment title"),
			descripcion: t("Entertainment room"),
			fondo: 'bg-entretenimiento',
			handleComponent: 'sala-entretenimiento',
			targetTour: 'atajo-juegos',
			permittedTo: typesTiposUsuario.todosUsuarios + typesTiposUsuario.gestion,

		},
		{
			icon: <FaMailBulk size={25} />,
			titulo: t('Consulting title'),
			descripcion: t("Consulting agenda"),
			fondo: 'bg-agenda',
			targetTour: 'agenda-asesorias',
			handleComponent: multiViewComponentsPaths.agendasAsesorias,
			permittedTo: typesTiposUsuario.todosUsuarios,

		},
		{
			icon: <FaChartBar size={25} />,
			titulo: t("Pomodoro title"),
			descripcion: t('Pomodoro Technique'),
			fondo: 'bg-pomodoro',
			handleComponent: 'pomodoro',
			targetTour: 'atajo-pomodoro',
			permittedTo: typesTiposUsuario.todosUsuarios + typesTiposUsuario.gestion,

		},

	]


	return (
		<>

			{ultimaLeccion !== null && (
				<Col className="last-action col-10 col-md-6 col-xl-4 col-xxl-3 p-3 atajo" style={{height: "200px"}}>
					<Row className="h-100 pointer " onClick={() => handleUltimaLeccion(ultimaLeccion)}>
						<Col className="col-4 justify-content-center" style={{backgroundColor: "#ffcc00", borderRadius: "10px 0px 0px 10px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
							<FaMapPin size={25} />
						</Col>
						<Col className="text-cente bg-continuacion" style={{ borderRadius: "0px 10px 10px 0px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
							<div className="d-flex flex-column text-start text-white">
								<h5>{t("Continue title")}</h5>
								<small>{t("Continue where you left off")}</small>
							</div>
						</Col>
					</Row>
				</Col>
			)}

			{atajosItems.map((atajo, idx) => (
				atajo.permittedTo.includes(rol) && (
					<Col key={idx} className={`${atajo.targetTour} col-10 col-md-6 col-xl-4 col-xxl-3 p-3 atajo`} style={{height: "200px"}}>
						<Row className="h-100 pointer " onClick={() => atajo.handleComponent === 'ultimaLeccion' ? handleUltimaLeccion(ultimaLeccion) : handleChangeComponent(atajo.handleComponent) }>
							<Col className="col-4 justify-content-center" style={{backgroundColor: "#ffcc00", borderRadius: "10px 0px 0px 10px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
								{atajo.icon}
							</Col>
							<Col className={`text-center ${atajo.fondo}`} style={{borderRadius: "0px 10px 10px 0px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
								<div className="d-flex flex-column text-start text-white">
									<h5>{atajo.titulo}</h5>
									<small>{atajo.descripcion}</small>
								</div>
							</Col>
						</Row>
					</Col>

				)
			))}

			{language === 'es' && (
				<Col className="descargar-app col-10 col-md-6 col-xl-4 col-xxl-3 p-3 atajo" style={{height: "200px"}}>
					<Row className="h-100 ">
						<Col className="col-4 justify-content-center" style={{backgroundColor: "#ffcc00", borderRadius: "10px 0px 0px 10px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
							<Image fluid src={require('@assets/images/qrClickplus.png')} width={"100%"} height={"90%"}/>
						</Col>
						<Col className="text-cente bg-click-movil" style={{ borderRadius: "0px 10px 10px 0px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
							<div className="d-flex flex-column text-start text-white">
								<h5>Descargar Click+ Móvil</h5>
								<small>Gestiona tu progreso, solicita tu estado de cuenta y disfruta de lecciones optimizadas para que puedas disfrutarlas donde quiera que vayas. Sin costo adicional.</small>
							</div>
						</Col>
					</Row>
				</Col>

			)}

			{(rol === 'administrador' || rol === 'cobranza') && (
				<Col className="mis-avances col-10 col-md-6 col-xl-4 col-xxl-3 p-3 atajo" style={{height: "200px"}}>
					<Row className="h-100 pointer " onClick={()=> handleChangeComponent('panelAdministracion')}>
						<Col className="col-4 justify-content-center" style={{backgroundColor: "#ffcc00", borderRadius: "10px 0px 0px 10px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
							<FaUser size={25} />
						</Col>
						<Col className="text-center bg-administrador" style={{ borderRadius: "0px 10px 10px 0px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
							<div className="d-flex flex-column text-start text-white">
								<h5>{t("Admin title")}</h5>
								<small>{t("Admin Panel")}</small>
							</div>
						</Col>
					</Row>
				</Col>
			)}

			{(nombreUsuario === 'rh@globalclickmexico.com') && (
				<Col className="mis-avances col-10 col-md-6 col-xl-4 col-xxl-3 p-3 atajo" style={{height: "200px"}}>
					<Row className="h-100 pointer " onClick={()=> handleChangeComponent('homeCompetenciaLecturaVeloz')}>
						<Col className="col-4 justify-content-center" style={{backgroundColor: "#ffcc00", borderRadius: "10px 0px 0px 10px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
							<FaUser size={25} />
						</Col>
						<Col className="text-center bg-administrador" style={{ borderRadius: "0px 10px 10px 0px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
							<div className="d-flex flex-column text-start text-white">
								<h5>Foro de Lectura GC</h5>
								<small>Mira el avance de los participantes del concurso interno de Lectura Inteligente</small>
							</div>
						</Col>
					</Row>
				</Col>
			)}

			
		</>
	);
};

export default AtajosUsuarioEstudiante;
